import React, { Component } from 'react'; // eslint-disable-line

/**
 * You should base your renderer on the `BaseRenderer` if you want to create a new type of renderer. Then you will get the
 * default cell renderer styling out of the box in addition to support for description, tags, badge icons and popup menu.
 *
 * **vimond-core-components** has 3 renderers that you can use:
 *
 * `BaseRenderer`: is a basic renderer that supports showing a title, description, a footer message, tags, icon badges and a
 * popup menu. It is used as a base for the other renderers.
 *
 * `ContentRenderer`: This is a renderer that is typically used to renderer assets, categories, content panel items, etc. It
 * supports displaying an image to the left and allows the image to be displayed as a folder to indicate that the user can
 * double click on the item to drill down.
 *
 * `IconRenderer`: This a renderer that displays an icon to the left of the information.
 *
 * This documentation describes the props in `BaseRenderer`.
 * @property {string} className The class name of this renderer. Will be appended to "core-base-renderer".
 * @property {node} description The description for a cell. Can be a markup.
 * @property {string} error An error string. If this prop is defined the renderer will display an error icon. Hovering the
 * mouse over this icon will display the error message in a tooltip.
 * @property {node} footer The footer text for a cell. Can be a markup.
 * @property {node} icons The icons you want to add to a cell. Will be displayed in the lower right corner of the cell.
 * @property {string} imageUrl An image url that will be displayed for `ContentRenderer`.
 * @property {object} item The item that a cell represents. The item will be passed on to the *onCreateMenuItems* callback.
 * @property {number} level Defines which heading level will be created for this cell. Defaults to 3 (`h3`).
 * @property {function} onCreateMenuItems A callback that is triggered when the user has clicked on a cell's action menu.
 * @property {function} onClose A callback that is called when the popup menu is closed.
 * @property {string} tag The tag label want to display before the icons. This should be the state of your item such
 * as "Draft", "Modified", etc. May be used in combination with *tags*.
 * @property {array} tags Array of string tag labels. Use this prop when you need multiple tag labels instead of just
 * one. May be used in combination with *tag*.
 * @property {node} title The title of the cell or a custom React component. The *level* prop will determine which heading
 * will be created.
 * @property {string} warning A warning string. If this prop is defined the renderer will display a warning icon. Hovering
 * the mouse over this icon will display the warning message in a tooltip.
 *
 * @see <a href="https://github.com/vimond/vimond-core-components/blob/master/src/components/Renderers/BaseRenderer.jsx"><code>BaseRenderer</code></a>,
 * <a href="https://github.com/vimond/vimond-core-components/blob/master/src/components/Renderers/ContentRenderer.jsx"><code>ContentRenderer</code></a>,
 * <a href="https://github.com/vimond/vimond-core-components/blob/master/src/components/Renderers/IconRenderer.jsx"><code>IconRenderer</code></a>,
 * List
 */
export default class Renderers extends Component {

  // This is just a dummy component that is only used as a placeholder for the documentation
  render() {
    return null;
  }

}
